import {
    INCREMENT_FAILED_RECEIPT_COUNT,
    MARK_RECEIPT_GENERATED,
    UPDATE_RECEIPT_CALL_BEGIN,
    UPDATE_RECEIPT_CALL_END,
  } from "../actions/retryReceiptAction";
  
  const initialState = {
    receiptCallHappening: false,
    receiptGenerated: false,
    receiptFailCount: 0,
    transactionID: "",
  };
  
  const retryReceiptReducer = (state = initialState, action) => {
    switch (action.type) {
      case UPDATE_RECEIPT_CALL_BEGIN:
        return {
          ...state,
          receiptCallHappening: true,
        };
  
      case MARK_RECEIPT_GENERATED:
        return {
          ...state,
          receiptGenerated: true,
        };
  
      case INCREMENT_FAILED_RECEIPT_COUNT:
        return {
          ...state,
          receiptFailCount: state.receiptFailCount + 1,
        };
  
      case UPDATE_RECEIPT_CALL_END:
        return {
          ...state,
          receiptCallHappening: false,
        };
  
      default:
        return state;
    }
  };
  
  export default retryReceiptReducer;